/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var createFormSubmissionCookie = function (formSubmissionId, logger) {
    if (!formSubmissionId) {
        logger.log("No formSubmissionId available. Skipping creation of formSubmissionId cookie.");
        return;
    }
    var disableCookiesUsage = window["disableCookiesUsage"];
    if (typeof disableCookiesUsage === "function" && disableCookiesUsage()) {
        logger.log("Nonessential cookies are disabled. Skipping creation of formSubmissionId cookie.");
        return;
    }
    var cookieString = "msdynmkt_formsubmissionid=".concat(formSubmissionId, ";path=/;max-age=31536000");
    document.cookie = cookieString;
};
